import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

import t from '../lib/I18n';

export class PaypalStore extends BaseStore {

    getInitialState () {
        return super.getInitialState().merge({
            addressError: null,
            clientToken: null,
        });
    }

    getClientToken () {
        return this.get('clientToken');
    }

    handleAddressError({ countryCode }) {
        let newAddressError = null;

        if (countryCode) {
          newAddressError = t('payment.paypal.chooseCorrectAddress', { countryCode });
        }
        this.setState(this.state.merge({
          addressError: newAddressError
        }));
    }

    handleToken ({ token }) {
        this.setState(this.state.set('clientToken', token));
    }

    getActionHandlers () {
        return {
            [ActionTypes.PAYPAL_ADDRESS_ERROR]: this.handleAddressError,
            [ActionTypes.PAYPAL_CLIENT_TOKEN_LOADED]: this.handleToken,
            [ActionTypes.LOGGED_OUT]: this.resetState
        };
    }
}

const instance = new PaypalStore();

export default instance;



// WEBPACK FOOTER //
// ./src/stores/PaypalStore.js